import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "../content/blog/manifest.generated";

const BlogPage = () => {
  const { t, i18n } = useTranslation();

  const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString(i18n.language, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  return (
    <div className="mt-8 font-helveticaNeue w-full">
      <section>
        <h1 className="text-2xl font-bold mb-4">{t("blog.title")}</h1>
      </section>

      {articles.length === 0 ? (
        <p className="text-gray-500 dark:text-gray-400">
          {t("blog.emptyState")}
        </p>
      ) : (
        <section className="mt-8">
          <div className="flex flex-col gap-8">
            {articles.map((article) => (
              <article key={article.slug}>
                <h2 className="font-medium">
                  <Link
                    to={`/blog/${article.slug}`}
                    className="text-blue-700 dark:text-blue-400 hover:text-white dark:hover:text-white hover:bg-blue-700"
                  >
                    {article.title}
                  </Link>
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {formatDate(article.date)}
                </p>
                {article.excerpt && <p className="mt-1">{article.excerpt}</p>}
              </article>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default BlogPage;
